import AxiosPermisos  from './../axiosPermisos'

import {
  path
} from './path'

const AuthWithSSOService = async ({ params = {} }) => await AxiosPermisos.post(path.sso, false, params, 'v2')

export {
  AuthWithSSOService
}